import { Divider, Typography } from 'antd'
import React from 'react'
import BinTransitDashboard from '../../../components/Wash/BinTransitDashboard/BinTransitDashboard'

const WashBinTransitPage = () => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          Intransit Dashboard
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <BinTransitDashboard />
    </>
  )
}

export default WashBinTransitPage